import { ABP, eLayoutType } from '@abp/ng.core';

export const applicationRoutes: ABP.Route[] = [
  {
    path: '/',
    name: 'Menu::MenuG:Home',
    iconClass: 'fas fa-home',
    layout: eLayoutType.application,
    requiredPolicy: 'Nb.Mtp.MtpFeatureHome.Menu',
    order: 1001,
  },
  {
    path: '',
    name: 'Menu::MenuG:DayAhead',
    iconClass: 'fas fa-clock',
    layout: eLayoutType.application,
    requiredPolicy: 'Nb.Nav.DayAhead.Menu',
    order: 1002,
  },
  {
    path: '/amt/market-overview-X-dam',
    name: 'Menu::MenuG:MarketOverviewDam',
    parentName: 'Menu::MenuG:DayAhead',
    requiredPolicy: 'Nb.Amt.MarketOverviewDam.Menu',
    order: 1003,
  },
  {
    path: '',
    name: 'Menu::MenuG:SingleOrder',
    parentName: 'Menu::MenuG:DayAhead',
    layout: eLayoutType.application,
    requiredPolicy: 'Nb.Nav.SingleOrder.Menu',
    order: 1004,
  },
  {
    path: '/amt/order-form-X-dam',
    name: 'Menu::MenuG:OrderFormDam',
    parentName: 'Menu::MenuG:SingleOrder',
    requiredPolicy: 'Nb.Amt.OrderFormDam.Menu',
    order: 1005,
  },
  {
    path: '/amt/orders-all-portfolios-X-dam',
    name: 'Menu::MenuG:OrdersAllPortfoliosDam',
    parentName: 'Menu::MenuG:SingleOrder',
    requiredPolicy: 'Nb.Amt.OrdersAllPortfoliosDam.Menu',
    order: 1006,
  },
  {
    path: '/amt/portfolio-order-status-X-dam',
    name: 'Menu::MenuG:PortfolioOrderStatusDam',
    parentName: 'Menu::MenuG:SingleOrder',
    requiredPolicy: 'Nb.Amt.PortfolioOrderStatusDam.Menu',
    order: 1007,
  },
  {
    path: '/amt/portfolio-bid-curves-X-dam',
    name: 'Menu::MenuG:PortfolioBidCurvesDam',
    parentName: 'Menu::MenuG:SingleOrder',
    requiredPolicy: 'Nb.Amt.PortfolioBidCurvesDam.Menu',
    order: 1008,
  },
  {
    path: '/amt/amt-price-development-dashboard-X-dam',
    name: 'Menu::MenuG:BidPointDashboardDam',
    parentName: 'Menu::MenuG:SingleOrder',
    requiredPolicy: 'Nb.Amt.AmtPriceDevelopmentDashboardDam.Menu',
    order: 1009,
  },
  {
    path: '/amt/trading-process-X-dam',
    name: 'Menu::MenuG:PriceCalculationDam',
    parentName: 'Menu::MenuG:DayAhead',
    requiredPolicy: 'Nb.Amt.TradingProcessDam.Menu',
    order: 1010,
  },
  {
    path: '',
    name: 'Menu::MenuG:MarketResultDam',
    parentName: 'Menu::MenuG:DayAhead',
    layout: eLayoutType.application,
    requiredPolicy: 'Nb.Nav.MarketResultDam.Menu',
    order: 1011,
  },
  {
    path: '/amt/portfolio-schedule-X-dam',
    name: 'Menu::MenuG:PortfolioScheduleDam',
    parentName: 'Menu::MenuG:MarketResultDam',
    requiredPolicy: 'Nb.Amt.PortfolioScheduleDam.Menu',
    order: 1012,
  },
  {
    path: '/amt/schedules-all-portfolios-X-dam',
    name: 'Menu::MenuG:SchedulesAllPortfoliosDam',
    parentName: 'Menu::MenuG:MarketResultDam',
    requiredPolicy: 'Nb.Amt.SchedulesAllPortfoliosDam.Menu',
    order: 1013,
  },
  {
    path: '/amt/prices-and-turnover-X-dam',
    name: 'Menu::MenuG:PricesAndTurnoverDam',
    parentName: 'Menu::MenuG:MarketResultDam',
    requiredPolicy: 'Nb.Amt.PricesAndTurnoverDam.Menu',
    order: 1014,
  },
  {
    path: '/amt/trade-per-currency-X-dam',
    name: 'Menu::MenuG:TradedAmountsDam',
    parentName: 'Menu::MenuG:MarketResultDam',
    requiredPolicy: 'Nb.Amt.TradePerCurrencyDam.Menu',
    order: 1015,
  },
  {
    path: '/setrep/document-generation-X-dam',
    name: 'Menu::MenuG:GenerateDocumentsDam',
    parentName: 'Menu::MenuG:MarketResultDam',
    requiredPolicy: 'Nb.Setrep.DocumentGenerationDam.Menu',
    order: 1016,
  },
  {
    path: '/amt/exact-prices-X-dam',
    name: 'Menu::MenuG:ExactPricesDam',
    parentName: 'Menu::MenuG:DayAhead',
    requiredPolicy: 'Nb.Amt.ExactPricesDam.Menu',
    order: 1017,
  },
  {
    path: '',
    name: 'Menu::MenuG:MarketCrossDam',
    parentName: 'Menu::MenuG:DayAhead',
    layout: eLayoutType.application,
    requiredPolicy: 'Nb.Nav.MarketCrossDam.Menu',
    order: 1018,
  },
  {
    path: '/amt/unconstrained-market-cross-X-dam',
    name: 'Menu::MenuG:UnconstrainedMarketCrossDam',
    parentName: 'Menu::MenuG:MarketCrossDam',
    requiredPolicy: 'Nb.Amt.UnconstrainedMarketCrossDam.Menu',
    order: 1019,
  },
  {
    path: '/amt/area-market-cross-X-dam',
    name: 'Menu::MenuG:AreaMarketCrossDam',
    parentName: 'Menu::MenuG:MarketCrossDam',
    requiredPolicy: 'Nb.Amt.AreaMarketCrossDam.Menu',
    order: 1020,
  },
  {
    path: '/tsam/amt-flow-X-dam',
    name: 'Menu::MenuG:DamFlow',
    parentName: 'Menu::MenuG:DayAhead',
    requiredPolicy: 'Nb.Tsam.AmtFlowDam.Menu',
    order: 1021,
  },
  {
    path: '/amt/curtailment-X-dam',
    name: 'Menu::MenuG:CurtailmentDam',
    parentName: 'Menu::MenuG:DayAhead',
    requiredPolicy: 'Nb.Amt.CurtailmentDam.Menu',
    order: 1022,
  },
  {
    path: '/amt/area-net-exchange-X-dam',
    name: 'Menu::MenuG:AreaNetExchangeDam',
    parentName: 'Menu::MenuG:DayAhead',
    requiredPolicy: 'Nb.Amt.AreaNetExchangeDam.Menu',
    order: 1023,
  },
  {
    path: '/emmd/portfolio-result-adjustment-X-dam',
    name: 'Menu::MenuG:ResultAdjustmentsDam',
    parentName: 'Menu::MenuG:DayAhead',
    requiredPolicy: 'Nb.Emmd.PortfolioResultAdjustmentDam.Menu',
    order: 1024,
  },
  {
    path: '',
    name: 'Menu::MenuG:Fpm',
    iconClass: 'fas fa-calendar',
    layout: eLayoutType.application,
    requiredPolicy: 'Nb.Nav.Fpm.Menu',
    order: 1025,
  },
  {
    path: '/amt/market-overview-X-fpm',
    name: 'Menu::MenuG:MarketOverviewFpm',
    parentName: 'Menu::MenuG:Fpm',
    requiredPolicy: 'Nb.Amt.MarketOverviewFpm.Menu',
    order: 1026,
  },
  {
    path: '',
    name: 'Menu::MenuG:FpmOrders',
    parentName: 'Menu::MenuG:Fpm',
    layout: eLayoutType.application,
    requiredPolicy: 'Nb.Nav.FpmOrders.Menu',
    order: 1027,
  },
  {
    path: '/amt/order-form-X-fpm',
    name: 'Menu::MenuG:OrderFormFpm',
    parentName: 'Menu::MenuG:FpmOrders',
    requiredPolicy: 'Nb.Amt.OrderFormFpm.Menu',
    order: 1028,
  },
  {
    path: '/amt/orders-all-portfolios-X-fpm',
    name: 'Menu::MenuG:OrdersAllPortfoliosFpm',
    parentName: 'Menu::MenuG:FpmOrders',
    requiredPolicy: 'Nb.Amt.OrdersAllPortfoliosFpm.Menu',
    order: 1029,
  },
  {
    path: '/amt/portfolio-order-status-X-fpm',
    name: 'Menu::MenuG:PortfolioOrderStatusFpm',
    parentName: 'Menu::MenuG:FpmOrders',
    requiredPolicy: 'Nb.Amt.PortfolioOrderStatusFpm.Menu',
    order: 1030,
  },
  {
    path: '/amt/portfolio-bid-curves-X-fpm',
    name: 'Menu::MenuG:PortfolioBidCurvesFpm',
    parentName: 'Menu::MenuG:FpmOrders',
    requiredPolicy: 'Nb.Amt.PortfolioBidCurvesFpm.Menu',
    order: 1031,
  },
  {
    path: '/amt/amt-price-development-dashboard-X-fpm',
    name: 'Menu::MenuG:BidPointDashboardFpm',
    parentName: 'Menu::MenuG:FpmOrders',
    requiredPolicy: 'Nb.Amt.AmtPriceDevelopmentDashboardFpm.Menu',
    order: 1032,
  },
  {
    path: '/amt/trading-process-X-fpm',
    name: 'Menu::MenuG:PriceCalculationFpm',
    parentName: 'Menu::MenuG:Fpm',
    requiredPolicy: 'Nb.Amt.TradingProcessFpm.Menu',
    order: 1033,
  },
  {
    path: '',
    name: 'Menu::MenuG:MarketResultFpm',
    parentName: 'Menu::MenuG:Fpm',
    layout: eLayoutType.application,
    requiredPolicy: 'Nb.Nav.MarketResultFpm.Menu',
    order: 1034,
  },
  {
    path: '/amt/portfolio-schedule-X-fpm',
    name: 'Menu::MenuG:PortfolioScheduleFpm',
    parentName: 'Menu::MenuG:MarketResultFpm',
    requiredPolicy: 'Nb.Amt.PortfolioScheduleFpm.Menu',
    order: 1035,
  },
  {
    path: '/amt/schedules-all-portfolios-X-fpm',
    name: 'Menu::MenuG:SchedulesAllPortfoliosFpm',
    parentName: 'Menu::MenuG:MarketResultFpm',
    requiredPolicy: 'Nb.Amt.SchedulesAllPortfoliosFpm.Menu',
    order: 1036,
  },
  {
    path: '/amt/prices-and-turnover-X-fpm',
    name: 'Menu::MenuG:PricesAndTurnoverFpm',
    parentName: 'Menu::MenuG:MarketResultFpm',
    requiredPolicy: 'Nb.Amt.PricesAndTurnoverFpm.Menu',
    order: 1037,
  },
  {
    path: '/amt/trade-per-currency-X-fpm',
    name: 'Menu::MenuG:TradedAmountsFpm',
    parentName: 'Menu::MenuG:MarketResultFpm',
    requiredPolicy: 'Nb.Amt.TradePerCurrencyFpm.Menu',
    order: 1038,
  },
  {
    path: '/setrep/document-generation-X-fpm',
    name: 'Menu::MenuG:GenerateDocumentsFpm',
    parentName: 'Menu::MenuG:MarketResultFpm',
    requiredPolicy: 'Nb.Setrep.DocumentGenerationFpm.Menu',
    order: 1039,
  },
  {
    path: '/amt/exact-prices-X-fpm',
    name: 'Menu::MenuG:ExactPricesFpm',
    parentName: 'Menu::MenuG:Fpm',
    requiredPolicy: 'Nb.Amt.ExactPricesFpm.Menu',
    order: 1040,
  },
  {
    path: '',
    name: 'Menu::MenuG:MarketCrossFpm',
    parentName: 'Menu::MenuG:Fpm',
    layout: eLayoutType.application,
    requiredPolicy: 'Nb.Nav.MarketCrossFpm.Menu',
    order: 1041,
  },
  {
    path: '/amt/unconstrained-market-cross-X-fpm',
    name: 'Menu::MenuG:UnconstrainedMarketCrossFpm',
    parentName: 'Menu::MenuG:MarketCrossFpm',
    requiredPolicy: 'Nb.Amt.UnconstrainedMarketCrossFpm.Menu',
    order: 1042,
  },
  {
    path: '/amt/area-market-cross-X-fpm',
    name: 'Menu::MenuG:AreaMarketCrossFpm',
    parentName: 'Menu::MenuG:MarketCrossFpm',
    requiredPolicy: 'Nb.Amt.AreaMarketCrossFpm.Menu',
    order: 1043,
  },
  {
    path: '/tsam/amt-flow-X-fpm',
    name: 'Menu::MenuG:FpmFlow',
    parentName: 'Menu::MenuG:Fpm',
    requiredPolicy: 'Nb.Tsam.AmtFlowFpm.Menu',
    order: 1044,
  },
  {
    path: '/amt/curtailment-X-fpm',
    name: 'Menu::MenuG:CurtailmentFpm',
    parentName: 'Menu::MenuG:Fpm',
    requiredPolicy: 'Nb.Amt.CurtailmentFpm.Menu',
    order: 1045,
  },
  {
    path: '/amt/area-net-exchange-X-fpm',
    name: 'Menu::MenuG:AreaNetExchangeFpm',
    parentName: 'Menu::MenuG:Fpm',
    requiredPolicy: 'Nb.Amt.AreaNetExchangeFpm.Menu',
    order: 1046,
  },
  {
    path: '/emmd/portfolio-result-adjustment-X-fpm',
    name: 'Menu::MenuG:ResultAdjustmentsFpm',
    parentName: 'Menu::MenuG:Fpm',
    requiredPolicy: 'Nb.Emmd.PortfolioResultAdjustmentFpm.Menu',
    order: 1047,
  },
  {
    path: '',
    name: 'Menu::MenuG:IntraDay',
    iconClass: 'fas fa-hourglass',
    layout: eLayoutType.application,
    requiredPolicy: 'Nb.Nav.IntraDay.Menu',
    order: 1048,
  },
  {
    path: '/cmt/bid-and-ask',
    name: 'Menu::MenuG:BidAndAsk',
    parentName: 'Menu::MenuG:IntraDay',
    requiredPolicy: 'Nb.Cmt.BidAndAsk.Menu',
    order: 1049,
  },
  {
    path: '/tsam/view-atc-X-idm',
    name: 'Menu::MenuG:ViewAtcIdm',
    parentName: 'Menu::MenuG:IntraDay',
    requiredPolicy: 'Nb.Tsam.ViewAtcIdm.Menu',
    order: 1050,
  },
  {
    path: '/tsam/manage-atc-X-idm',
    name: 'Menu::MenuG:ManageAtcIdm',
    parentName: 'Menu::MenuG:IntraDay',
    requiredPolicy: 'Nb.Tsam.ManageAtcIdm.Menu',
    order: 1051,
  },
  {
    path: '/cmt/suspend-market',
    name: 'Menu::MenuG:SuspendMarket',
    parentName: 'Menu::MenuG:IntraDay',
    requiredPolicy: 'Nb.Cmt.SuspendMarket.Menu',
    order: 1052,
  },
  {
    path: '/cmt/order-history',
    name: 'Menu::MenuG:OrderHistory',
    parentName: 'Menu::MenuG:IntraDay',
    requiredPolicy: 'Nb.Cmt.OrderHistory.Menu',
    order: 1053,
  },
  {
    path: '/cmt/bid-validation-stats',
    name: 'Menu::MenuG:BidValidationStatistics',
    parentName: 'Menu::MenuG:IntraDay',
    requiredPolicy: 'Nb.Cmt.BidValidationStats.Menu',
    order: 1054,
  },
  {
    path: '/cmt/result-adjustments',
    name: 'Menu::MenuG:ResultAdjustmentsIdm',
    parentName: 'Menu::MenuG:IntraDay',
    requiredPolicy: 'Nb.Cmt.ResultAdjustments.Menu',
    order: 1055,
  },
  {
    path: '/cmt/price-development-dashboard',
    name: 'Menu::MenuG:PriceDevelopmentDashboard',
    parentName: 'Menu::MenuG:IntraDay',
    requiredPolicy: 'Nb.Cmt.PriceDevelopmentDashboard.Menu',
    order: 1056,
  },
  {
    path: '/setrep/document-generation-X-idm',
    name: 'Menu::MenuG:GenerateDocumentsIntraDay',
    parentName: 'Menu::MenuG:IntraDay',
    requiredPolicy: 'Nb.Setrep.DocumentGenerationIdm.Menu',
    order: 1057,
  },
  {
    path: '',
    name: 'Menu::MenuG:BalancingMarket',
    iconClass: 'fas fa-chart-bar',
    layout: eLayoutType.application,
    requiredPolicy: 'Nb.Nav.BalancingMarket.Menu',
    order: 1058,
  },
  {
    path: '/bm/order-book',
    name: 'Menu::MenuG:OrderBook',
    parentName: 'Menu::MenuG:BalancingMarket',
    requiredPolicy: 'Nb.Bm.OrderBook.Menu',
    order: 1059,
  },
  {
    path: '/bm/merit-order-stack',
    name: 'Menu::MenuG:MeritOrderStack',
    parentName: 'Menu::MenuG:BalancingMarket',
    requiredPolicy: 'Nb.Bm.MeritOrderStack.Menu',
    order: 1060,
  },
  {
    path: '/tsam/view-atc-X-bm',
    name: 'Menu::MenuG:ViewAtcBm',
    parentName: 'Menu::MenuG:BalancingMarket',
    requiredPolicy: 'Nb.Tsam.ViewAtcBm.Menu',
    order: 1061,
  },
  {
    path: '/tsam/manage-atc-X-bm',
    name: 'Menu::MenuG:ManageAtcBm',
    parentName: 'Menu::MenuG:BalancingMarket',
    requiredPolicy: 'Nb.Tsam.ManageAtcBm.Menu',
    order: 1062,
  },
  {
    path: '/bm/tso-report-X-requesting-tso',
    name: 'Menu::MenuG:RequestingTsoReport',
    parentName: 'Menu::MenuG:BalancingMarket',
    requiredPolicy: 'Nb.Bm.TsoReportRequestingTso.Menu',
    order: 1063,
  },
  {
    path: '/bm/tso-report-X-supplying-tso',
    name: 'Menu::MenuG:SupplyingTsoReport',
    parentName: 'Menu::MenuG:BalancingMarket',
    requiredPolicy: 'Nb.Bm.TsoReportSupplyingTso.Menu',
    order: 1064,
  },
  {
    path: '/setrep/document-generation-X-bm',
    name: 'Menu::MenuG:GenerateDocumentsBM',
    parentName: 'Menu::MenuG:BalancingMarket',
    requiredPolicy: 'Nb.Setrep.DocumentGenerationBm.Menu',
    order: 1065,
  },
  {
    path: '',
    name: 'Menu::MenuG:ManageMarkets',
    iconClass: 'fas fa-university',
    layout: eLayoutType.application,
    requiredPolicy: 'Nb.Nav.ManageMarkets.Menu',
    order: 1066,
  },
  {
    path: '/emmd/view-currency-rates',
    name: 'Menu::MenuG:ViewCurrencyRate',
    parentName: 'Menu::MenuG:ManageMarkets',
    requiredPolicy: 'Nb.Emmd.ViewCurrencyRates.Menu',
    order: 1067,
  },
  {
    path: '/tsam/intercon-gen-event-register',
    name: 'Menu::MenuG:InterconAndGenEventRegister',
    parentName: 'Menu::MenuG:ManageMarkets',
    requiredPolicy: 'Nb.Tsam.InterconGenEventRegister.Menu',
    order: 1068,
  },
  {
    path: '',
    name: 'Menu::MenuG:ManageInterconCapacity',
    parentName: 'Menu::MenuG:ManageMarkets',
    layout: eLayoutType.application,
    requiredPolicy: 'Nb.Nav.ManageInterconCapacity.Menu',
    order: 1069,
  },
  {
    path: '/tsam/manage-intercon-prod-sched',
    name: 'Menu::MenuG:ManageInterconProductSchedules',
    parentName: 'Menu::MenuG:ManageInterconCapacity',
    requiredPolicy: 'Nb.Tsam.ManageInterconProdSched.Menu',
    order: 1070,
  },
  {
    path: '/tsam/manage-missing-intercon-prod-sched',
    name: 'Menu::MenuG:ManageMissingCapacities',
    parentName: 'Menu::MenuG:ManageInterconCapacity',
    requiredPolicy: 'Nb.Tsam.ManageMissingInterconProdSched.Menu',
    order: 1071,
  },
  {
    path: '/tsam/view-invalid-atc',
    name: 'Menu::MenuG:ViewInvalidAtcs',
    parentName: 'Menu::MenuG:ManageInterconCapacity',
    requiredPolicy: 'Nb.Tsam.ViewInvalidAtc.Menu',
    order: 1072,
  },
  {
    path: '/tsam/manage-ttc',
    name: 'Menu::MenuG:ManageTtc',
    parentName: 'Menu::MenuG:ManageInterconCapacity',
    requiredPolicy: 'Nb.Tsam.ManageTtc.Menu',
    order: 1073,
  },
  {
    path: '/tsam/intercon-event',
    name: 'Menu::MenuG:ManageInterconEvents',
    parentName: 'Menu::MenuG:ManageInterconCapacity',
    requiredPolicy: 'Nb.Tsam.InterconEvent.Menu',
    order: 1074,
  },
  {
    path: '/tsam/generation-event',
    name: 'Menu::MenuG:ManageGenerationEvents',
    parentName: 'Menu::MenuG:ManageInterconCapacity',
    requiredPolicy: 'Nb.Tsam.GenerationEvent.Menu',
    order: 1075,
  },
  {
    path: '/tsam/ttc-deviation-dashboard',
    name: 'Menu::MenuG:TtcDeviationDashboard',
    parentName: 'Menu::MenuG:ManageInterconCapacity',
    requiredPolicy: 'Nb.Tsam.TtcDeviationDashboard.Menu',
    order: 1076,
  },
  {
    path: '/tsam/ttc-deviation-stats',
    name: 'Menu::MenuG:TtcDeviationStats',
    parentName: 'Menu::MenuG:ManageInterconCapacity',
    requiredPolicy: 'Nb.Tsam.TtcDeviationStats.Menu',
    order: 1077,
  },
  {
    path: '',
    name: 'Menu::MenuG:InterconCapacityAllocation',
    parentName: 'Menu::MenuG:ManageMarkets',
    layout: eLayoutType.application,
    requiredPolicy: 'Nb.Nav.InterconCapacityAllocation.Menu',
    order: 1078,
  },
  {
    path: '/tsam/view-intercon-prod-sched',
    name: 'Menu::MenuG:ViewInterconProductSchedules',
    parentName: 'Menu::MenuG:InterconCapacityAllocation',
    requiredPolicy: 'Nb.Tsam.ViewInterconProdSched.Menu',
    order: 1079,
  },
  {
    path: '/tsam/view-intercon-interval-sched',
    name: 'Menu::MenuG:ViewInterconIntervalSchedules',
    parentName: 'Menu::MenuG:InterconCapacityAllocation',
    requiredPolicy: 'Nb.Tsam.ViewInterconIntervalSched.Menu',
    order: 1080,
  },
  {
    path: '/tsam/intercon-allocation-dashboard',
    name: 'Menu::MenuG:InterconAllocationDashboard',
    parentName: 'Menu::MenuG:InterconCapacityAllocation',
    requiredPolicy: 'Nb.Tsam.InterconAllocationDashboard.Menu',
    order: 1081,
  },
  {
    path: '/tsam/scada-intercon-flow',
    name: 'Menu::MenuG:ScadaInterconEnergyMeasurement',
    parentName: 'Menu::MenuG:InterconCapacityAllocation',
    requiredPolicy: 'Nb.Tsam.ScadaInterconFlow.Menu',
    order: 1082,
  },
  {
    path: '/tsam/sched-vs-scada-flows',
    name: 'Menu::MenuG:ScheduledVsScadaMeasurement',
    parentName: 'Menu::MenuG:InterconCapacityAllocation',
    requiredPolicy: 'Nb.Tsam.SchedVsScadaFlows.Menu',
    order: 1083,
  },
  {
    path: '',
    name: 'Menu::MenuG:ScheduleAdjustments',
    parentName: 'Menu::MenuG:ManageMarkets',
    layout: eLayoutType.application,
    requiredPolicy: 'Nb.Nav.ScheduleAdjustments.Menu',
    order: 1084,
  },
  {
    path: '/tsam/mtp-flow-adjustments',
    name: 'Menu::MenuG:ManageFlowAdjustments',
    parentName: 'Menu::MenuG:ScheduleAdjustments',
    requiredPolicy: 'Nb.Tsam.MtpFlowAdjustments.Menu',
    order: 1085,
  },
  {
    path: '/tsam/manage-cntrl-area-imbalance-sched',
    name: 'Menu::MenuG:ManageImbalanceSchedules',
    parentName: 'Menu::MenuG:ManageMarkets',
    requiredPolicy: 'Nb.Tsam.ManageCntrlAreaImbalanceSched.Menu',
    order: 1086,
  },
  {
    path: '',
    name: 'Menu::MenuG:BilateralContracting',
    iconClass: 'fas fa-gear',
    layout: eLayoutType.application,
    requiredPolicy: 'Nb.Nav.BilateralContracting.Menu',
    order: 1087,
  },
  {
    path: '/tsam/bilateral-schedules',
    name: 'Menu::MenuG:BilateralSchedules',
    parentName: 'Menu::MenuG:BilateralContracting',
    requiredPolicy: 'Nb.Tsam.BilateralSchedules.Menu',
    order: 1088,
  },
  {
    path: '/tsam/final-bilateral-nomination',
    name: 'Menu::MenuG:FinalBilateralNomination',
    parentName: 'Menu::MenuG:BilateralContracting',
    requiredPolicy: 'Nb.Tsam.FinalBilateralNomination.Menu',
    order: 1089,
  },
  {
    path: '/tsam/emergency-energy-nomination',
    name: 'Menu::MenuG:EmergencyEnergyNomination',
    parentName: 'Menu::MenuG:BilateralContracting',
    requiredPolicy: 'Nb.Tsam.EmergencyEnergyNomination.Menu',
    order: 1090,
  },
  {
    path: '',
    name: 'Menu::MenuG:Settlements',
    iconClass: 'fas fa-calculator',
    layout: eLayoutType.application,
    requiredPolicy: 'Nb.Nav.Settlements.Menu',
    order: 1091,
  },
  {
    path: '/setrep/document-type',
    name: 'Menu::MenuG:DocumentTypes',
    parentName: 'Menu::MenuG:Settlements',
    requiredPolicy: 'Nb.Setrep.DocumentType.Menu',
    order: 1092,
  },
  {
    path: '/setrep/data-entity',
    name: 'Menu::MenuG:DataEntities',
    parentName: 'Menu::MenuG:Settlements',
    requiredPolicy: 'Nb.Setrep.DataEntity.Menu',
    order: 1093,
  },
  {
    path: '/setrep/settlement-parameter',
    name: 'Menu::MenuG:SettlementParameters',
    parentName: 'Menu::MenuG:Settlements',
    requiredPolicy: 'Nb.Setrep.SettlementParameter.Menu',
    order: 1094,
  },
  {
    path: '/setrep/manage-settlements',
    name: 'Menu::MenuG:ManageSettlements',
    parentName: 'Menu::MenuG:Settlements',
    requiredPolicy: 'Nb.Setrep.ManageSettlements.Menu',
    order: 1095,
  },
  {
    path: '',
    name: 'Menu::MenuG:SettlementResults',
    parentName: 'Menu::MenuG:Settlements',
    layout: eLayoutType.application,
    requiredPolicy: 'Nb.Nav.SettlementResults.Menu',
    order: 1096,
  },
  {
    path: '/setrep/settlement-results-X-portfolio',
    name: 'Menu::MenuG:PortfolioResults',
    parentName: 'Menu::MenuG:SettlementResults',
    requiredPolicy: 'Nb.Setrep.SettlementResultsPortfolio.Menu',
    order: 1097,
  },
  {
    path: '/setrep/settlement-results-X-area',
    name: 'Menu::MenuG:AreaResults',
    parentName: 'Menu::MenuG:SettlementResults',
    requiredPolicy: 'Nb.Setrep.SettlementResultsArea.Menu',
    order: 1098,
  },
  {
    path: '/setrep/settlement-results-X-company',
    name: 'Menu::MenuG:CompanyResults',
    parentName: 'Menu::MenuG:SettlementResults',
    requiredPolicy: 'Nb.Setrep.SettlementResultsCompany.Menu',
    order: 1099,
  },
  {
    path: '/setrep/document-generation',
    name: 'Menu::MenuG:GenerateDocuments',
    parentName: 'Menu::MenuG:Settlements',
    requiredPolicy: 'Nb.Setrep.DocumentGeneration.Menu',
    order: 1100,
  },
  {
    path: '',
    name: 'Menu::MenuG:OperatingReporting',
    iconClass: 'fas fa-chart-bar',
    layout: eLayoutType.application,
    requiredPolicy: 'Nb.Nav.OperatingReporting.Menu',
    order: 1101,
  },
  {
    path: '/setrep/settlement-parameter-X-operating-reporting',
    name: 'Menu::MenuG:SettlementParametersOperatingReporting',
    parentName: 'Menu::MenuG:OperatingReporting',
    requiredPolicy: 'Nb.Setrep.SettlementParameterOperatingReporting.Menu',
    order: 1102,
  },
  {
    path: '/setrep/manage-settlements-X-operating-reporting',
    name: 'Menu::MenuG:ManageSettlementsOperatingReporting',
    parentName: 'Menu::MenuG:OperatingReporting',
    requiredPolicy: 'Nb.Setrep.ManageSettlementsOperatingReporting.Menu',
    order: 1103,
  },
  {
    path: '/setrep/document-generation-X-operating-reporting',
    name: 'Menu::MenuG:GenerateDocumentsOperatingReporting',
    parentName: 'Menu::MenuG:OperatingReporting',
    requiredPolicy: 'Nb.Setrep.DocumentGenerationOperatingReporting.Menu',
    order: 1104,
  },
  {
    path: '',
    name: 'Menu::MenuG:Configuration',
    iconClass: 'fas fa-tools',
    layout: eLayoutType.application,
    requiredPolicy: 'Nb.Nav.Configuration.Menu',
    order: 1105,
  },
  {
    path: '',
    name: 'Menu::MenuG:AccessControl',
    parentName: 'Menu::MenuG:Configuration',
    layout: eLayoutType.application,
    requiredPolicy: 'Nb.Nav.AccessControl.Menu',
    order: 1106,
  },
  {
    path: '/aum/company-X-access',
    name: 'Menu::MenuG:CompaniesAccess',
    parentName: 'Menu::MenuG:AccessControl',
    requiredPolicy: 'Nb.Aum.CompanyAccess.Menu',
    order: 1107,
  },
  {
    path: '/aum/user',
    name: 'Menu::MenuG:Users',
    parentName: 'Menu::MenuG:AccessControl',
    requiredPolicy: 'Nb.Aum.User.Menu',
    order: 1108,
  },
  {
    path: '/aum/user-activity-log-X-all-user',
    name: 'Menu::MenuG:AccessLogs',
    parentName: 'Menu::MenuG:AccessControl',
    requiredPolicy: 'Nb.Aum.UserActivityLogAllUser.Menu',
    order: 1109,
  },
  {
    path: '/samm/samm-parameter-X-module-access',
    name: 'Menu::MenuG:ModuleParameterAccess',
    parentName: 'Menu::MenuG:AccessControl',
    requiredPolicy: 'Nb.Samm.SammParameterModuleAccess.Menu',
    order: 1110,
  },
  {
    path: '/samm/samm-parameter-X-application-access',
    name: 'Menu::MenuG:ApplicationParameterAccess',
    parentName: 'Menu::MenuG:AccessControl',
    requiredPolicy: 'Nb.Samm.SammParameterApplicationAccess.Menu',
    order: 1111,
  },
  {
    path: '/aum/user-activity-log-X-user-login-monitor',
    name: 'Menu::MenuG:UserLoginActivity',
    parentName: 'Menu::MenuG:AccessControl',
    requiredPolicy: 'Nb.Aum.UserActivityLogUserLoginMonitor.Menu',
    order: 1112,
  },
  {
    path: '/menu/menu-access-overview',
    name: 'Menu::MenuG:MenuAccessOverview',
    parentName: 'Menu::MenuG:AccessControl',
    requiredPolicy: 'Nb.Menu.MenuAccessOverview.Menu',
    order: 1113,
  },
  {
    path: '',
    name: 'Menu::MenuG:SolutionParameters',
    parentName: 'Menu::MenuG:Configuration',
    layout: eLayoutType.application,
    requiredPolicy: 'Nb.Nav.SolutionParameters.Menu',
    order: 1114,
  },
  {
    path: '/samm/samm-parameter-X-module-value',
    name: 'Menu::MenuG:ModuleParameters',
    parentName: 'Menu::MenuG:SolutionParameters',
    requiredPolicy: 'Nb.Samm.SammParameterModuleValue.Menu',
    order: 1115,
  },
  {
    path: '/samm/samm-parameter-X-application-value',
    name: 'Menu::MenuG:ApplicationParameters',
    parentName: 'Menu::MenuG:SolutionParameters',
    requiredPolicy: 'Nb.Samm.SammParameterApplicationValue.Menu',
    order: 1116,
  },
  {
    path: '',
    name: 'Menu::MenuG:TxAllocationManagement',
    parentName: 'Menu::MenuG:Configuration',
    layout: eLayoutType.application,
    requiredPolicy: 'Nb.Nav.TxAllocationManagement.Menu',
    order: 1117,
  },
  {
    path: '/tsam/country-management',
    name: 'Menu::MenuG:Countries',
    parentName: 'Menu::MenuG:TxAllocationManagement',
    requiredPolicy: 'Nb.Tsam.CountryManagement.Menu',
    order: 1118,
  },
  {
    path: '/tsam/area-management',
    name: 'Menu::MenuG:Areas',
    parentName: 'Menu::MenuG:TxAllocationManagement',
    requiredPolicy: 'Nb.Tsam.AreaManagement.Menu',
    order: 1119,
  },
  {
    path: '/tsam/interconnector-management',
    name: 'Menu::MenuG:Interconnectors',
    parentName: 'Menu::MenuG:TxAllocationManagement',
    requiredPolicy: 'Nb.Tsam.InterconnectorManagement.Menu',
    order: 1120,
  },
  {
    path: '/tsam/transmission-path-management',
    name: 'Menu::MenuG:TxPaths',
    parentName: 'Menu::MenuG:TxAllocationManagement',
    requiredPolicy: 'Nb.Tsam.TransmissionPathManagement.Menu',
    order: 1121,
  },
  {
    path: '/tsam/bilateral-contract-management',
    name: 'Menu::MenuG:BilateralContracts',
    parentName: 'Menu::MenuG:TxAllocationManagement',
    requiredPolicy: 'Nb.Tsam.BilateralContractManagement.Menu',
    order: 1122,
  },
  {
    path: '/tsam/file-upload-log',
    name: 'Menu::MenuG:TsamLossFactorFileUpload',
    parentName: 'Menu::MenuG:TxAllocationManagement',
    requiredPolicy: 'Nb.Tsam.FileUploadLog.Menu',
    order: 1123,
  },
  {
    path: '',
    name: 'Menu::MenuG:MasterData',
    parentName: 'Menu::MenuG:Configuration',
    layout: eLayoutType.application,
    requiredPolicy: 'Nb.Nav.MasterData.Menu',
    order: 1124,
  },
  {
    path: '',
    name: 'Menu::MenuG:Markets',
    parentName: 'Menu::MenuG:MasterData',
    layout: eLayoutType.application,
    requiredPolicy: 'Nb.Nav.Markets.Menu',
    order: 1125,
  },
  {
    path: '/emmd/market-product-definition',
    name: 'Menu::MenuG:MarketProductDefinition',
    parentName: 'Menu::MenuG:Markets',
    requiredPolicy: 'Nb.Emmd.MarketProductDefinition.Menu',
    order: 1126,
  },
  {
    path: '/emmd/portfolio-management',
    name: 'Menu::MenuG:Portfolios',
    parentName: 'Menu::MenuG:MasterData',
    requiredPolicy: 'Nb.Emmd.PortfolioManagement.Menu',
    order: 1127,
  },
  {
    path: '/cal/calendar-management',
    name: 'Menu::MenuG:Calendar',
    parentName: 'Menu::MenuG:MasterData',
    requiredPolicy: 'Nb.Cal.CalendarManagement.Menu',
    order: 1128,
  },
  {
    path: '/aum/company-X-master-data',
    name: 'Menu::MenuG:CompaniesMasterData',
    parentName: 'Menu::MenuG:MasterData',
    requiredPolicy: 'Nb.Aum.CompanyMasterData.Menu',
    order: 1129,
  },
  {
    path: '',
    name: 'Menu::MenuG:TimeOfUse',
    parentName: 'Menu::MenuG:Configuration',
    layout: eLayoutType.application,
    requiredPolicy: 'Nb.Nav.TimeOfUse.Menu',
    order: 1130,
  },
  {
    path: '/tou/tou-management',
    name: 'Menu::MenuG:TouDefinition',
    parentName: 'Menu::MenuG:TimeOfUse',
    requiredPolicy: 'Nb.Tou.TouManagement.Menu',
    order: 1131,
  },
  {
    path: '/tou/tou-structure',
    name: 'Menu::MenuG:TouStructure',
    parentName: 'Menu::MenuG:TimeOfUse',
    requiredPolicy: 'Nb.Tou.TouStructure.Menu',
    order: 1132,
  },
  {
    path: '/tou/tou-dashboard',
    name: 'Menu::MenuG:TouDashboard',
    parentName: 'Menu::MenuG:TimeOfUse',
    requiredPolicy: 'Nb.Tou.TouDashboard.Menu',
    order: 1133,
  },
  {
    path: '/tou/tou-day-override',
    name: 'Menu::MenuG:ManagePublicHolidays',
    parentName: 'Menu::MenuG:TimeOfUse',
    requiredPolicy: 'Nb.Tou.TouDayOverride.Menu',
    order: 1134,
  },
  {
    path: '',
    name: 'Menu::MenuG:SettlementAndReportingConfiguration',
    parentName: 'Menu::MenuG:Configuration',
    layout: eLayoutType.application,
    requiredPolicy: 'Nb.Nav.SettlementAndReportingConfiguration.Menu',
    order: 1135,
  },
  {
    path: '/setrep/document-type-X-configuration',
    name: 'Menu::MenuG:DocumentTypesConfiguration',
    parentName: 'Menu::MenuG:SettlementAndReportingConfiguration',
    requiredPolicy: 'Nb.Setrep.DocumentTypeConfiguration.Menu',
    order: 1136,
  },
  {
    path: '/setrep/data-entity-X-configuration',
    name: 'Menu::MenuG:DataEntitiesConfiguration',
    parentName: 'Menu::MenuG:SettlementAndReportingConfiguration',
    requiredPolicy: 'Nb.Setrep.DataEntityConfiguration.Menu',
    order: 1137,
  },
  {
    path: '/setrep/settlement-parameter-X-configuration',
    name: 'Menu::MenuG:SettlementParametersConfiguration',
    parentName: 'Menu::MenuG:SettlementAndReportingConfiguration',
    requiredPolicy: 'Nb.Setrep.SettlementParameterConfiguration.Menu',
    order: 1138,
  },
  {
    path: '',
    name: 'Menu::MenuG:MarketSurveillance',
    iconClass: 'fas fa-gear',
    layout: eLayoutType.application,
    requiredPolicy: 'Nb.Nav.MarketSurveillance.Menu',
    order: 1139,
  },
  {
    path: '/smas/shiny-dashboard',
    name: 'Menu::MenuG:ShinyDashboard',
    parentName: 'Menu::MenuG:MarketSurveillance',
    requiredPolicy: 'Nb.Smas.ShinyDashboard.Menu',
    order: 1140,
  },
  {
    path: '/smas/market-watchlists',
    name: 'Menu::MenuG:MarketWatchlists',
    parentName: 'Menu::MenuG:MarketSurveillance',
    requiredPolicy: 'Nb.Smas.MarketWatchlists.Menu',
    order: 1141,
  },
  {
    path: '/smas/market-incidents-dashboard',
    name: 'Menu::MenuG:MarketIncidents',
    parentName: 'Menu::MenuG:MarketSurveillance',
    requiredPolicy: 'Nb.Smas.MarketIncidentsDashboard.Menu',
    order: 1142,
  },
  {
    path: '/smas/market-cases',
    name: 'Menu::MenuG:MarketCases',
    parentName: 'Menu::MenuG:MarketSurveillance',
    requiredPolicy: 'Nb.Smas.MarketCases.Menu',
    order: 1143,
  },
  {
    path: '/smas/market-cases-stats',
    name: 'Menu::MenuG:CaseStatistics',
    parentName: 'Menu::MenuG:MarketSurveillance',
    requiredPolicy: 'Nb.Smas.MarketCasesStats.Menu',
    order: 1144,
  },
  {
    path: '',
    name: 'Menu::MenuG:Administration',
    iconClass: 'fas fa-gear',
    layout: eLayoutType.application,
    requiredPolicy: 'Nb.Nav.Administration.Menu',
    order: 1145,
  },
  {
    path: '/mdd/message-inbox',
    name: 'Menu::MenuG:MessageInbox',
    parentName: 'Menu::MenuG:Administration',
    requiredPolicy: 'Nb.Mdd.MessageInbox.Menu',
    order: 1146,
  },
  {
    path: '/smas/tickets',
    name: 'Menu::MenuG:SupportTickets',
    parentName: 'Menu::MenuG:Administration',
    requiredPolicy: 'Nb.Smas.Tickets.Menu',
    order: 1147,
  },
  {
    path: '/smas/ticket-statistics',
    name: 'Menu::MenuG:TicketStatistics',
    parentName: 'Menu::MenuG:Administration',
    requiredPolicy: 'Nb.Smas.TicketStatistics.Menu',
    order: 1148,
  },
  {
    path: '/nav-file-management',
    name: 'Menu::MenuG:FileManagement',
    parentName: 'Menu::MenuG:Administration',
    requiredPolicy: 'Nb.AbpFileManagement.AbpFileManagement.Menu',
    order: 1149,
  },
  {
    path: '/scheduler/dashboard',
    name: 'Menu::MenuG:BackgroundProcesses',
    parentName: 'Menu::MenuG:Administration',
    requiredPolicy: 'Nb.Scheduler.Dashboard.Menu',
    order: 1150,
  },
  {
    path: '/bulkdownload/bulk-download-log',
    name: 'Menu::MenuG:BulkDownloadLog',
    parentName: 'Menu::MenuG:Administration',
    requiredPolicy: 'Nb.BulkDownload.BulkDownloadLog.Menu',
    order: 1151,
  },
  {
    path: '',
    name: 'Menu::MenuG:ThirdPartyIntegration',
    iconClass: 'fas fa-file-import',
    layout: eLayoutType.application,
    requiredPolicy: 'Nb.Nav.ThirdPartyIntegration.Menu',
    order: 1152,
  },
  {
    path: '',
    name: 'Menu::MenuG:Scada',
    parentName: 'Menu::MenuG:ThirdPartyIntegration',
    layout: eLayoutType.application,
    requiredPolicy: 'Nb.Nav.Scada.Menu',
    order: 1153,
  },
  {
    path: '/sappmtp/scheduler-log',
    name: 'Menu::MenuG:ScadaSchedulerLog',
    parentName: 'Menu::MenuG:Scada',
    requiredPolicy: 'Nb.Sappmtp.SchedulerLog.Menu',
    order: 1154,
  },
  {
    path: '/sappmtp/file-load-log',
    name: 'Menu::MenuG:ScadaFileLoadLog',
    parentName: 'Menu::MenuG:Scada',
    requiredPolicy: 'Nb.Sappmtp.FileLoadLog.Menu',
    order: 1155,
  },
  {
    path: '/sappmtp/file-generate-log',
    name: 'Menu::MenuG:ScadaFileGenerateLog',
    parentName: 'Menu::MenuG:Scada',
    requiredPolicy: 'Nb.Sappmtp.FileGenerateLog.Menu',
    order: 1156,
  },
];
